module.exports = __webpack_public_path__ + "img/m_addClient.39cc7be1.png";